module.exports = __webpack_public_path__ + "img/st.99f2907a.png";